module.exports = __webpack_public_path__ + "img/fast_car.6fa1ad08.svg";